import React, { useState } from "react";
import "../Footer.css";
import { Link } from "react-router-dom";

import logo from "../../assets/saivari-logo-1.png";

import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiArrowUp,
  FiArrowRight,
} from "react-icons/fi";

import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";

const Footer = () => {

  const [email, setEmail] = useState("");
  const [subscribeMessage, setSubscribeMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ================= SUBSCRIBE =================
  const handleSubscribe = (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();

    // Empty email validation
    if (!trimmedEmail) {
      setMessageType("error");
      setSubscribeMessage("Please enter your email address.");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedEmail)) {
      setMessageType("error");
      setSubscribeMessage("Please enter a valid email address.");
      return;
    }

    // Success
    setMessageType("success");
    setSubscribeMessage("Thank you for subscribing!");

    // Clear input
    setEmail("");
  };


  return (
    <footer className="footer">

      {/* ================= NEWSLETTER ================= */}

      <section className="footer-newsletter">
        <div className="container newsletter-wrapper">

          <div className="newsletter-content">
            <span className="newsletter-tag">
              Stay Connected
            </span>

            <h2>
              Get the Latest FinTech Insights
            </h2>

            <p>
              Subscribe to receive industry news, compliance
              updates, technology trends and business insights.
            </p>
          </div>

         <div className="newsletter-form-wrapper">

            <form
              className="newsletter-form"
              onSubmit={handleSubscribe}
            >

              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);

                  // Remove previous message when user starts typing
                  if (subscribeMessage) {
                    setSubscribeMessage("");
                    setMessageType("");
                  }
                }}
              />

              <button type="submit">
                Subscribe
                <FiArrowRight />
              </button>

            </form>

            {subscribeMessage && (
              <p
                className={`subscribe-message ${
                  messageType === "success"
                    ? "success-message"
                    : "error-message"
                }`}
              >
                {subscribeMessage}
              </p>
            )}

          </div>

        </div>
      </section>

      {/* ================= MAIN FOOTER ================= */}

      <div className="footer-main">
        <div className="container footer-grid">

          {/* COMPANY */}

          <div className="footer-column footer-company">

            <img
              src={logo}
              alt="Saivari Fintech"
              className="footer-logo"
            />

            <p>
              Saivari Fintech Private Limited provides
              innovative auxiliary services for FinTech,
              banking, lending, payment and digital
              financial businesses with secure,
              scalable and compliant technology
              solutions.
            </p>



          </div>

          {/* QUICK LINKS */}

          <div className="footer-column">

            <h3>Quick Links</h3>

            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/industries">Industries</a>
            <a href="/resources">Resources</a>
            <a href="/contact">Contact</a>

          </div>

          {/* SERVICES */}

          <div className="footer-column">

            <h3>Solutions</h3>

            <a href="/fintech-consulting">
              FinTech Consulting
            </a>

            <a href="/payment-solutions">
              Payment Solutions
            </a>

            <a href="/compliance-support">
              Compliance Support
            </a>


            <a href="/aml-managed">
              AML Managed
            </a>

            <a href="/third-party-risk-management">
              Third Party Risk
            </a>

            <a href="/kyc-verification">
              KYC Verification
            </a>

          </div>

          {/* INDUSTRIES */}

          

          {/* CONTACT */}

          <div className="footer-column">

            <h3>Contact</h3>

            <div className="contact-item">
              <FiMapPin />
              <span>
                Plot No 532 To 534, Ayyappa Society,
                Madhapur, Cyberabad, Hyderabad,
                Shaikpet, Telangana, India, 500081
              </span>
            </div>

            <div className="contact-item">
              <FiPhone />
              <span>
                +919799536210
              </span>
            </div>

            <div className="contact-item">
              <FiMail />
              <span>
                support@techsaivari.in
              </span>
            </div>

          </div>

        </div>
      </div>

      {/* ================= BOTTOM ================= */}

      <div className="footer-bottom">

        <div className="container footer-bottom-wrapper">

          <p>
            © {new Date().getFullYear()} Saivari Fintech Private Limited.
            All Rights Reserved.
          </p>

          <div className="footer-policy">

            <a href="/privacy-policy">
              Privacy Policy
            </a>

            <a href="/terms-conditions">
              Terms & Conditions
            </a>

          </div>

        </div>

      </div>

      {/* ================= SCROLL TOP ================= */}

      <button
        className="scroll-top"
        onClick={scrollTop}
      >
        <FiArrowUp />
      </button>

    </footer>
  );
};

export default Footer;